import ProductDetailsBa from './ba/quotes/product_details';
import ProductDetailsBg from './bg/quotes/product_details';
import ProductDetailsCn from './cn/quotes/product_details';
import ProductDetailsTw from './tw/quotes/product_details';
import ProductDetailsDe from './de/quotes/product_details';
import ProductDetailsDk from './dk/quotes/product_details';
import ProductDetailsEn from './en/quotes/product_details';
import ProductDetailsEs from './es/quotes/product_details';
import ProductDetailsFi from './fi/quotes/product_details';
import ProductDetailsFr from './fr/quotes/product_details';
import ProductDetailsHr from './hr/quotes/product_details';
import ProductDetailsHu from './hu/quotes/product_details';
import ProductDetailsGr from './gr/quotes/product_details';
import ProductDetailsIt from './it/quotes/product_details';
import ProductDetailsJp from './jp/quotes/product_details';
import ProductDetailsLt from './lt/quotes/product_details';
import ProductDetailsLv from './lv/quotes/product_details';
import ProductDetailsMe from './me/quotes/product_details';
import ProductDetailsMk from './mk/quotes/product_details';
import ProductDetailsMt from './mt/quotes/product_details';
import ProductDetailsNl from './nl/quotes/product_details';
import ProductDetailsPl from './pl/quotes/product_details';
import ProductDetailsPt from './pt/quotes/product_details';
import ProductDetailsRs from './rs/quotes/product_details';
import ProductDetailsSe from './se/quotes/product_details';
import ProductDetailsTr from './tr/quotes/product_details';
import ProductDetailsUs from './en-us/quotes/product_details';

export default {
    messages: {
        ba: { ProductDetails: ProductDetailsBa },
        bg: { ProductDetails: ProductDetailsBg },
        cn: { ProductDetails: ProductDetailsCn },
        tw: { ProductDetails: ProductDetailsTw },
        de: { ProductDetails: ProductDetailsDe },
        dk: { ProductDetails: ProductDetailsDk },
        en: { ProductDetails: ProductDetailsEn },
        'en-us': { ProductDetails: ProductDetailsUs },
        es: { ProductDetails: ProductDetailsEs },
        fi: { ProductDetails: ProductDetailsFi },
        fr: { ProductDetails: ProductDetailsFr },
        hr: { ProductDetails: ProductDetailsHr },
        hu: { ProductDetails: ProductDetailsHu },
        gr: { ProductDetails: ProductDetailsGr },
        it: { ProductDetails: ProductDetailsIt },
        jp: { ProductDetails: ProductDetailsJp },
        lt: { ProductDetails: ProductDetailsLt },
        lv: { ProductDetails: ProductDetailsLv },
        me: { ProductDetails: ProductDetailsMe },
        mk: { ProductDetails: ProductDetailsMk },
        mt: { ProductDetails: ProductDetailsMt },
        mx: { ProductDetails: ProductDetailsEs },
        nl: { ProductDetails: ProductDetailsNl },
        pl: { ProductDetails: ProductDetailsPl },
        pt: { ProductDetails: ProductDetailsPt },
        rs: { ProductDetails: ProductDetailsRs },
        se: { ProductDetails: ProductDetailsSe },
        tr: { ProductDetails: ProductDetailsTr },
    },
};
